/** "13466" → 13466; anything that is not a plain non-negative integer → null. */
export function parseOutcomeId(raw: string | undefined): number | null {
  if (!raw || !/^\d{1,15}$/.test(raw)) return null;
  const n = Number(raw);
  return Number.isSafeInteger(n) ? n : null;
}
